(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("AFRAME"), require("THREE"));
	else if(typeof define === 'function' && define.amd)
		define(["AFRAME", "THREE"], factory);
	else if(typeof exports === 'object')
		exports["campus"] = factory(require("AFRAME"), require("THREE"));
	else
		root["campus"] = factory(root["AFRAME"], root["THREE"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_aframe__, __WEBPACK_EXTERNAL_MODULE_three__) => {
return 